import type { IconSvgObject } from './types';

const HotAirBalloonIcon: IconSvgObject = [
  ["path", { d: "M14.5 18H9.5C8.94772 18 8.5 18.4477 8.5 19V21C8.5 21.5523 8.94772 22 9.5 22H14.5C15.0523 22 15.5 21.5523 15.5 21V19C15.5 18.4477 15.0523 18 14.5 18Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 8.93333C20 14 14.4615 18 12 18C9.53846 18 4 14 4 8.93333C4 5.10416 7.58172 2 12 2C16.4183 2 20 5.10416 20 8.93333Z", stroke: "currentColor", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M15 8.93333C15 14 12.9231 18 12 18C11.0769 18 9 14 9 8.93333C9 5.10416 10.3431 2 12 2C13.6569 2 15 5.10416 15 8.93333Z", stroke: "currentColor", strokeWidth: "1.5", key: "2" }]
];

export default HotAirBalloonIcon;
